// One-time device codes (docs/07 "Enrolment and activation"): a user's first device enrols
// with one. An administrator with UpdateUser issues one for a user with no active device;
// accepting an invitation shows one too.
import { api, type Schemas } from "../api/client";
import { unwrap } from "../api/queries";

export type DeviceCode = Schemas["DeviceCodeDto"];

/** A user's code: fifteen minutes, single use; replaces any earlier one. */
export function issueDeviceCode(userId: string): Promise<DeviceCode> {
  return unwrap(api.POST("/api/admin/users/{user_id}/device-code", { params: { path: { user_id: userId } } }));
}
